/* eslint-disable react/no-unused-prop-types */
import { ChangeEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import TablePagination from '@mui/material/TablePagination';
import VisibilityIcon from '@mui/icons-material/Visibility';
import {
  Breadcrumbs,
  Container,
  IconButton,
  TableContainer,
  Typography,
  Link as MuiLink,
  Paper,
} from '@mui/material';
import { useListWebhooksQuery } from '../services/webhooks.endpoints';

const WebhookList = () => {
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10); // New state for rows per page
  const {
    data: webhooks,
    isLoading,
    isError,
    error,
  } = useListWebhooksQuery({
    page,
    limit: rowsPerPage,
  });

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event: ChangeEvent<HTMLInputElement>) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(1);
  };

  // const limit = users?.limit;
  // const totalPages = users?.totalPages;
  if (isLoading) {
    return <div>Loading</div>;
  }

  if (isError) {
    if ('status' in error) {
      return <div>Error: {error.status}</div>;
    }
    return <div>An error occurred</div>;
  }

  if (webhooks === undefined || webhooks.totalDocs === 0) {
    return <div>No webhooks found</div>;
  }

  const { totalDocs } = webhooks;

  return (
    <Container maxWidth="lg" sx={{ px: 0 }}>
      <Breadcrumbs aria-label="breadcrumb" sx={{ mb: 1 }}>
        <MuiLink underline="hover" color="inherit" href="/#">
          Home
        </MuiLink>
        <Typography color="text.primary">Webhooks</Typography>
      </Breadcrumbs>

      <Typography variant="h4" gutterBottom sx={{ mb: 4 }}>
        Webhooks
      </Typography>
      <Box sx={{ width: '100%', mt: 3 }}>
        <Paper>
          <TableContainer>
            <Table
              sx={{
                '& .MuiTableCell-head': {
                  backgroundColor: 'rgba(224, 224, 224, 1)', // Adjust as needed
                  color: 'black',
                  fontWeight: 'bold',
                },
                minWidth: 700,
              }}
            >
              <TableHead>
                <TableRow>
                  <TableCell>Time</TableCell>
                  <TableCell>Type</TableCell>
                  <TableCell>Data</TableCell>
                  <TableCell align="right">Actions</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {webhooks.docs.map(({ _id: id, createdAt, type, data }) => (
                  <TableRow key={id}>
                    <TableCell>
                      {new Date(createdAt).toLocaleString()}
                    </TableCell>
                    <TableCell>{type}</TableCell>
                    <TableCell>
                      <Container
                        sx={{
                          display: 'block',
                          width: '300px',
                          whiteSpace: 'nowrap',
                          overflow: 'hidden',
                          textOverflow: 'ellipsis',
                        }}
                      >
                        {JSON.stringify(data, null, 2)}
                      </Container>
                    </TableCell>
                    <TableCell align="right">
                      <Link to={`/webhooks/${id}`}>
                        <IconButton>
                          <VisibilityIcon />
                        </IconButton>
                      </Link>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <TablePagination
            component="div"
            count={totalDocs}
            onPageChange={(event, newPage) => setPage(newPage + 1)}
            onRowsPerPageChange={(event) => {
              setRowsPerPage(parseInt(event.target.value, 10));
              setPage(1); // Reset to first page when rows per page changes
            }}
            page={page - 1}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </Paper>
      </Box>
    </Container>
  );
};

const Webhooks = () => {
  return (
    <Stack spacing={1} sx={{ padding: 2 }}>
      <WebhookList />
    </Stack>
  );
};

export default Webhooks;
